/*
* @Author: gujianghua
* @Date:   2018-08-13 11:49:31
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-17 18:48:39
*/
import { service } from '@/utils/request'

export default {
  //分页获取课程源列表
	getDataList: (data) => {
	    return service({
	      url: '/cloud/dvoice/v1/doconline/getDocOnlineList',
	      method: 'get',
	      params: data
	    })
	},
	// 上下架	
	switch: (data) => {
	    return service({
	    	headers:{
	        	'Content-Type': 'application/x-www-form-urlencoded'
	      	},
	      	transformRequest : [function (data) {
		        let newData = ''
		        for (let k in data) {
		          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
		        }
		        return newData
	      	}],
	      	url: '/cloud/dvoice/v1/doconline/setOnlineStatus',
	      	method: 'POST',
	      	data: data
	    })
	},
	// 全部提问
	getQuestionList: (data) => {
	    return service({
	      url: '/cloud/dvoice/v1/doconline/getDocOnlineQuestionListForApp',
	      method: 'get',
	      params: data
	    })
	},
	// 删除提问
	deleteQuestion(id) {
	    return service({
	      url: '/cloud/dvoice/v1/post/del/'+id,
	      method: 'get'
	    })
	},
	// 隐藏
	showOrNot(data) {
	    return service({
	    	headers:{
	        	'Content-Type': 'application/x-www-form-urlencoded'
	      	},
	      	transformRequest : [function (data) {
		        let newData = ''
		        for (let k in data) {
		          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
		        }
		        return newData
	      	}],
			url: '/cloud/dvoice/v1/post/changeaudit',
			method: 'post',
			data: data
	    })		
	},
	getDetail(data) {
	    return service({
	      url: '/cloud/dvoice/v1/post/model/'+data,
	      method: 'get'
	    })
	},
	// 添加
	addDoc(data) {
	    return service({
			url: '/cloud/dvoice/v1/doconline/addDocOnline',
			method: 'post',
			data: data
	    })		
	},
	// 详情
	docDetail(data) {
	    return service({
			url: '/cloud/dvoice/v1/doconline/model',
			method: 'get',
			params: data
	    })		
	},
	// 更新
	update(data) {
	    return service({
			url: '/cloud/dvoice/v1/doconline/update',
			method: 'post',
			data: data
	    })		
	}
}


// WEBPACK FOOTER //
// ./src/api/contentManage/famousDocOnline.js